/* eslint-disable jsx-a11y/anchor-is-valid */
import Link from 'next/link';
import React from 'react';
import ButtonLink from 'ui/src/components/Button/ButtonLink';
import { ThemeEnum } from 'ui/src/components/Theme';

// @TODO move to ui/src/components/Button/ButtonLink
const BlogButtonLink = ButtonLink<ThemeEnum.Site>;

type CategoryTitleProps = {
  category: string;
  slug: string;
};

export default function CategoryTitle({ category, slug }: CategoryTitleProps) {
  return (
    <>
      <Link
        href={`/category/${slug}/`}
        className="text-site-neutrals-900 site-overline-m font-bold uppercase hover:underline"
      >
        {category}
      </Link>
      <BlogButtonLink
        href={`/category/${slug}/`}
        variant="Tertiary"
        variantColor="Black"
        iconName="ArrowForward"
        size="Medium"
        classes=""
      >
        All {category} articles
      </BlogButtonLink>
    </>
  );
}
